VIV.behaviours.teaserNumber = (function () {

    const attach = function (context) {
        context.querySelectorAll('.teaserNumber').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {

    };

    return {
        attach: attach
    }
})();
